import * as v from 'valibot';

import { paginatedSchema } from '../_core.model';
import { countrySchema } from '../countries.model';
import { portTypeSchema } from '../port-types.model';
import { stateSchema } from '../states.model';

export const portSearchFormSchema = v.object({
  country: v.pipe(
    v.optional(countrySchema),
    v.check((value) => Boolean(value), 'Country is required'),
  ),
  portCity: v.optional(v.string()),
  portCode: v.optional(v.string()),
  portName: v.optional(v.string()),
  portPostal: v.optional(v.string()),
  portState: v.nullable(stateSchema),
  portType: v.nullable(portTypeSchema),
});

export const portSearchParamsSchema = v.object({
  country: v.optional(v.string()),
  limit: v.optional(v.pipe(v.number(), v.minValue(0)), 10),
  offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  portCity: v.optional(v.string()),
  portCode: v.optional(v.string()),
  portName: v.optional(v.string()),
  portPostal: v.optional(v.string()),
  portState: v.optional(v.string()),
  portType: v.optional(v.string()),
  sorting: v.optional(v.string()),
});

export const portSchema = v.object({
  city: v.nullish(v.string()),
  code: v.nullish(v.string()),
  countryCode: v.nullish(v.string()),
  id: v.number(),
  name: v.nullish(v.string()),
  state: v.nullish(v.string()),
  type: v.nullish(v.string()),
  zip: v.nullish(v.string()),
});

// TODO: swagger declares a bare array, every other master data vertical parses `{ items, totalCount }` —
// drop the union once the real response shape is confirmed.
export const portsResponseSchema = v.union([v.array(portSchema), paginatedSchema(portSchema)]);

export type PortSearchFormValues = v.InferOutput<typeof portSearchFormSchema>;
export type PortsParams = v.InferOutput<typeof portSearchParamsSchema>;
export type PortItem = v.InferOutput<typeof portSchema>;
export type PortsResponse = v.InferOutput<typeof portsResponseSchema>;
export type PortRow = Omit<PortItem, 'id'> & { id: string; portKey: number };
export type Ports = PortRow[];
export type PortsApi = { data: Ports; total: number };
